<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="alertSuccess" @delete-item="deleteType" @cancel="item = false"
            @error="showError"></view-item>

        <list-items v-else :title="$translate('interaction_types')" :items="interactionTypes" @show-item="showItem"
            ref="table">
            <b-button block variant="primary" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'interactionTypes',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [
        popupMixins,
        utilityMixins,
        permissionsMixins,
        errorHandlingMixins,
    ],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('interaction_type') },

        interactionTypes() {
            const interactionTypes =
                this.$store.state.interactionType.interaction_types
                || []
            return interactionTypes
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        async doSearch() {
            await this.$store.dispatch('interactionType/fetchAll')
        },

        showItem(id) {
            const item = this.interactionTypes.find(x => x.id === id)
            this.item = { ...item }
        },

        alertSuccess(action, message) {
            this.genericToast(
                this.componentName,
                this.$translate(`${action}d`),
                'success',
                `${this.componentName
                } ${message}`
            )
            this.item = null
            this.doSearch()
        },

        showError(error) {
            this.doToast(
                this.$translate('error'),
                `${error && error.message}`,
                'danger'
            )
        },
    },
}
</script>
<style></style>
